module.exports = __webpack_public_path__ + "static/media/image-web-2.bfd732bc.png";